import Giftcard from '@/views/admin/Giftcard.vue'
import GProcessed from '@/views/admin/giftcards/Processed.vue'
import GDeclined from '@/views/admin/giftcards/Declined.vue'
import GPending from '@/views/admin/giftcards/Pending.vue'

const giftcardRoutes = {
  path: '/hrd12/hrd12/giftcard',
  component: Giftcard,
  redirect: '/hrd12/hrd12/giftcard/processed',
  name: 'GiftcardGroup',
  meta: {
    title: 'Giftcard'
  },
  children: [
    {
      path: '/hrd12/hrd12/giftcard/processed',
      component: GProcessed,
      name: 'ProcessedGiftcard',
      meta: {
        title: 'Processed Giftcard'
      }
    },
    {
      path: '/hrd12/hrd12/giftcard/pending',
      component: GPending,
      name: 'PendingGiftcard',
      meta: {
        title: 'Pending Giftcard'
      }
    },
    {
      path: '/hrd12/hrd12/giftcard/declined',
      component: GDeclined,
      name: 'DeclinedGiftcard',
      meta: {
        title: 'Declined Giftcard'
      }
    }
  ]
}

export default giftcardRoutes
